import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { LandingPage } from "./pages/LandingPage";

const AdminPage = lazy(() => import("./pages/AdminPage").then((module) => ({ default: module.AdminPage })));
const ManageReportPage = lazy(() => import("./pages/ManageReportPage").then((module) => ({ default: module.ManageReportPage })));
const NewReportPage = lazy(() => import("./pages/NewReportPage").then((module) => ({ default: module.NewReportPage })));
const PrintReportPage = lazy(() => import("./pages/PrintReportPage").then((module) => ({ default: module.PrintReportPage })));
const PublicReportPage = lazy(() => import("./pages/PublicReportPage").then((module) => ({ default: module.PublicReportPage })));

export default function App() {
  return (
    <Suspense fallback={<div className="center-state full-page"><p>Loading…</p></div>}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/new" element={<NewReportPage />} />
        <Route path="/admin/reports/:id" element={<ManageReportPage />} />
        <Route path="/_print/:reportId/:revisionId" element={<PrintReportPage />} />
        <Route path="/:slug" element={<PublicReportPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
